import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getBonuses(params: any): AxiosPromise {
    return EndPointService.get('/bonuses', { params });
}

function getBonus(id: number | string): AxiosPromise {
    return EndPointService.get(`/bonuses/${id}`);
}

function generateBonus(payload: any): AxiosPromise {
    return EndPointService.post('/bonuses/generate', payload);
}

function getExigentBonusStatus(providerId: number | string): AxiosPromise {
    return EndPointService.get(`/bonuses/exigent-status/provider/${providerId}`);
}

export default {
    getBonuses,
    getBonus,
    generateBonus,
    getExigentBonusStatus,
};
